<div class="modal-header" *ngIf="showAsDialog" ngxModalDraggable>
    <h4 class="modal-title">Delivery Stack</h4>
</div>
<div class="modal-body flex-column flex-fill">
    <span *ngIf="true" class="my-2" styles="gap: 10px" [hidden]="showAsDialog">
        <button [hidden]="!uow.hasChanges()" (click)="save()" class="btn btn-sm btn-primary me-1">Save</button>
        <button [hidden]="!uow.hasChanges()" (click)="cancel()" class="btn btn-sm btn-danger">Cancel</button>
        <button [hidden]="uow.hasChanges()" (click)="close()" class="btn btn-sm btn-secondary">Close</button>
    </span>
    <dx-form [formData]="delivery" [colCount]="2" [readOnly]="readOnly || showAsDialog">
        <dxi-item itemType="group">
            <dxi-item dataField="id"[label]="{ text: 'Stack #' }" [disabled]="true" [editorOptions]="{ width: '150px' }"></dxi-item>
            <dxi-item dataField="scheduled" editorType="dxDateBox" [label]="{ text: 'Scheduled' }" [editorOptions]="{ width: '150px' }"></dxi-item>
            <dxi-item
                dataField="driverId"
                editorType="dxSelectBox"
                [editorOptions]="{ items: drivers, valueExpr: 'id', displayExpr: 'name' }"
                [label]="{ text: 'Driver' }"
            ></dxi-item>
            <dxi-item dataField="truckId" editorType="dxSelectBox" [editorOptions]="{ items: trucks, valueExpr: 'id', displayExpr: 'name' }" [label]="{ text: 'Truck' }"></dxi-item>
            <dxi-item
                dataField="trailerId"
                editorType="dxSelectBox"
                [editorOptions]="{ items: trailers, valueExpr: 'id', displayExpr: 'name' }"
                [label]="{ text: 'Trailer' }"
            ></dxi-item>
            <dxi-item
                dataField="transportPlateId"
                editorType="dxSelectBox"
                [editorOptions]="{ items: transportPlates, valueExpr: 'id', displayExpr: 'name' }"
                [label]="{ text: 'Transport Plate' }"
            ></dxi-item>
            <dxi-item *ngIf="showAsDialog" dataField="created"></dxi-item>
            <dxi-item *ngIf="showAsDialog" dataField="createdBy"></dxi-item>
            <dxi-item *ngIf="showAsDialog" dataField="deleted"></dxi-item>
            <dxi-item *ngIf="showAsDialog" dataField="deletedBy"></dxi-item>
        </dxi-item>
        <dxi-item dataField="notes" editorType="dxTextArea" [editorOptions]="{ height: '250px' }" [label]="{ text: 'Notes' }"></dxi-item>
    </dx-form>
    <div class="d-flex flex-row flex-fill mt-1 mb-3" [ngStyle]="{ height: showAsDialog ? '400px' : '100%' }">
        <dx-data-grid #stackDataGrid (onToolbarPreparing)="onToolbarPreparing($event)" class="h-100 grid-fill" [dataSource]="deliveryStacks" [showBorders]="true" keyExpr="id">
            <dxi-column dataField="stackPosition" caption="#" sortIndex="0" sortOrder="desc" [allowSorting]="false" width="60"></dxi-column>
            <dxi-column dataField="orderLineDetail.orderLine.order.dealer.displayName" caption="Dealer" [allowSorting]="false"></dxi-column>
            <dxi-column dataField="orderLineDetail.orderLine.partNumber" caption="Part #" [allowSorting]="false"></dxi-column>
            <dxi-column dataField="orderLineDetail.vIN" caption="VIN" [allowSorting]="false"></dxi-column>
            <dxi-column dataField="orderLineDetail.orderLine.order.shipToCity" caption="Ship To" [allowSorting]="false"></dxi-column>
            <dxi-column dataField="orderLineDetail.optionHTML" caption="Options" width="250" [encodeHtml]="false" [allowSorting]="false"></dxi-column>

            <dxo-sorting [mode]="'none'"></dxo-sorting>

            <dxo-row-dragging [allowReordering]="!readOnly" [onReorder]="onStackReorder" [showDragIcons]="true"></dxo-row-dragging>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button
                    class="btn btn-sm btn-danger"
                    (click)="remove(stackDataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="stackDataGrid.instance.getSelectedRowsData().length !== 1"
                    *ngIf="!readOnly"
                >
                    Remove
                </button>
            </div>
        </dx-data-grid>
    </div>
</div>
<div class="modal-footer" *ngIf="showAsDialog">
    <button type="button" (click)="closeDialog()" class="btn btn-success ms-1">Close</button>
</div>